export var API_UAT_URL = 'https://api-uat.syfbank.com';
export var AUTH_QA_URL = 'https://auth-qa.syf.com';
export var AKAMAI_URL = 'https://images.synchronycredit.com';
export var DEV_SANDBOX_URL = 'https://dev.synchronycredit.com';
//# sourceMappingURL=urls.js.map